import type { ClientOrganization } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';

import { OrganizationListItem } from '@/features/profile-setting/components/OrganizationListItem';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

type Props = {
  organizations: ClientOrganization[];
  describeOrganization: (
    organization: ClientOrganization
  ) => string | undefined;
  onOrganizationPress: (id: string) => void;
};

export const OrganizationAreaResultList: FC<Props> = ({
  organizations,
  describeOrganization,
  onOrganizationPress
}) => {
  const theme = useAppTheme();

  return (
    <>
      {organizations.map((organization) => (
        <OrganizationListItem
          key={organization.id}
          organization={organization}
          description={describeOrganization(organization)}
          onPress={() => onOrganizationPress(organization.id)}
          backgroundColor={theme.colors.surfaceContainerLowest}
        />
      ))}
    </>
  );
};
